<div>
  <h3 class="subtitulo">{{getTituloByTipoOrdem(true)}}</h3>
  <form [formGroup]="form">
    <div class="form-row ">
      <div class="col-7">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>Nome</mat-label>
          <input
            matInput
            placeholder="Nome"
            formControlName="nome"
            maxlength="55"
            noSpecialChars
            [attr.data-cy]="'input-nome-titular'"
          />
          <mat-hint align="end">{{nome.value?.length}} / 55</mat-hint>
          <mat-error *ngIf="nome.hasError('required')">
            Nome completo é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="nome.hasError('titularesEmpty')">
            {{getMensagemDeErroVazio()}}
          </mat-error>
          <mat-error *ngIf="nome.hasError('valueOnlyNumberError')">
            {{ getMensagemErroApenasNumeros() }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-3">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>CPF/CNPJ</mat-label>
          <input
            matInput
            type='text'
            mask="000.000.000-00||00.000.000/0000-00"
            placeholder="CPF/CNPJ"
            formControlName="documento"
            [attr.data-cy]="'input-documento-titular'"
          />
          <mat-error *ngIf="documento.hasError('required')">
            CPF/CNPJ é <strong>obrigat&oacute;rio</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-center align-items-center col-auto ">
        <button
          mat-button
          type="button"
          class="btn btn-branco"
          (click)="addTitular(nome.value, documento.value)"
          [disabled]="disableAddTitular()"
        >
          Adicionar
        </button>
      </div>
    </div>
  </form>

  <table mat-table class="mat-elevation-z2" [dataSource]="titulares" *ngIf="titulares.length > 0" aria-label="Tabela de Titulares">
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let titular"> {{titular.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="documento">
      <th mat-header-cell *matHeaderCellDef> Documento </th>
      <td mat-cell *matCellDef="let titular">
        {{ titular.documento | mask: isPessoaFisica(titular.documento) ? '000.000.000-00' : '00.000.000/0000-00' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Ações </th>
      <td mat-cell *matCellDef="let titular">
        <button mat-icon-button [matMenuTriggerFor]="menu" type="button">
          <mat-icon  class="table-icon">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="after">
          <button (click)="removerTitular(titular)" mat-menu-item>
            <mat-icon class="table-icon">close</mat-icon>
            <span>Excluir</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div class="form-row">
    <div class="info-message">
      <mat-icon class="info-icon" fontIcon="info"></mat-icon>
      <p>
        {{ getMensagemInformativa() }}
      </p>
    </div>
  </div>
</div>
